/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type {
  PerpetualMarketCoreTester,
  PerpetualMarketCoreTesterInterface
} from '../PerpetualMarketCoreTester'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_priceFeedAddress',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'productId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingRate',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'amountFundingPaidPerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'fundingPaidPerPosition',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'poolReceived',
        type: 'int256'
      }
    ],
    name: 'FundingPayment',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'minSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'maxSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'hedgeRateOfReturnThreshold',
        type: 'uint256'
      }
    ],
    name: 'SetHedgeParams',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'perpFutureMaxFundingRate',
        type: 'int256'
      }
    ],
    name: 'SetPerpFutureMaxFundingRate',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'poolMarginRiskParam',
        type: 'int256'
      }
    ],
    name: 'SetPoolMarginRiskParam',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'squaredPerpFundingMultiplier',
        type: 'int256'
      }
    ],
    name: 'SetSquaredPerpFundingMultiplier',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'tradeFeeRate',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'protocolFeeRate',
        type: 'int256'
      }
    ],
    name: 'SetTradeFeeRate',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'int256',
        name: 'variance',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'int256',
        name: 'underlyingPrice',
        type: 'int256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'timestamp',
        type: 'uint256'
      }
    ],
    name: 'VarianceUpdated',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'addLiquidity',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'amountLiquidity',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'amountUsdc',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'amountUnderlying',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'futureWeight',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'isLong',
            type: 'bool'
          }
        ],
        internalType: 'struct NettingLib.CompleteParams',
        name: '_completeParams',
        type: 'tuple'
      }
    ],
    name: 'completeHedgingProcedure',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_depositor',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      }
    ],
    name: 'deposit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'mintAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'executeFundingPayment',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_deltaLiquidityAmount',
        type: 'int256'
      }
    ],
    name: 'getLPTokenPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getNettingInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'int256[2]',
            name: 'amountsUsdc',
            type: 'int256[2]'
          },
          {
            internalType: 'uint256',
            name: 'amountUnderlying',
            type: 'uint256'
          }
        ],
        internalType: 'struct NettingLib.Info',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getTokenAmountForHedging',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'amountUsdc',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'amountUnderlying',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'futureWeight',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'isLong',
            type: 'bool'
          }
        ],
        internalType: 'struct NettingLib.CompleteParams',
        name: 'completeParams',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_tradeAmount',
        type: 'int128'
      }
    ],
    name: 'getTradePrice',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int128[2]',
        name: 'amountAssets',
        type: 'int128[2]'
      }
    ],
    name: 'getTradePriceInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'spotPrice',
            type: 'uint128'
          },
          {
            internalType: 'int256[2]',
            name: 'tradePrices',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'fundingRates',
            type: 'int256[2]'
          },
          {
            internalType: 'int256[2]',
            name: 'amountsFundingPaidPerPosition',
            type: 'int256[2]'
          }
        ],
        internalType: 'struct IPerpetualMarketCore.TradePriceInfo',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getUtilizationRatio',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_depositor',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_initialFundingRate',
        type: 'int256'
      }
    ],
    name: 'initialize',
    outputs: [
      {
        internalType: 'uint256',
        name: 'mintAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastHedgeSpotPrice',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'poolSnapshot',
    outputs: [
      {
        internalType: 'int128',
        name: 'futureBaseFundingRate',
        type: 'int128'
      },
      {
        internalType: 'int128',
        name: 'ethVariance',
        type: 'int128'
      },
      {
        internalType: 'int128',
        name: 'ethPrice',
        type: 'int128'
      },
      {
        internalType: 'uint128',
        name: 'lastSnapshotTime',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'pools',
    outputs: [
      {
        internalType: 'uint128',
        name: 'amountLockedLiquidity',
        type: 'uint128'
      },
      {
        internalType: 'int128',
        name: 'positionPerpetuals',
        type: 'int128'
      },
      {
        internalType: 'uint128',
        name: 'entryPrice',
        type: 'uint128'
      },
      {
        internalType: 'int256',
        name: 'amountFundingPaidPerPosition',
        type: 'int256'
      },
      {
        internalType: 'uint128',
        name: 'lastFundingPaymentTime',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'rebalance',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'result',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_minSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_maxSlippageToleranceOfHedge',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_hedgeRateOfReturnThreshold',
        type: 'uint256'
      }
    ],
    name: 'setHedgeParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_perpFutureMaxFundingRate',
        type: 'int256'
      }
    ],
    name: 'setPerpFutureMaxFundingRate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_perpetualMarket',
        type: 'address'
      }
    ],
    name: 'setPerpetualMarket',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_poolMarginRiskParam',
        type: 'int256'
      }
    ],
    name: 'setPoolMarginRiskParam',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int128',
        name: '_ethPrice',
        type: 'int128'
      },
      {
        internalType: 'int128',
        name: '_ethVariance',
        type: 'int128'
      },
      {
        internalType: 'uint128',
        name: '_lastSnapshotTime',
        type: 'uint128'
      }
    ],
    name: 'setPoolSnapshot',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_positionPerpetuals',
        type: 'int128'
      },
      {
        internalType: 'uint128',
        name: '_lastFundingPaymentTime',
        type: 'uint128'
      }
    ],
    name: 'setPoolStatus',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_squaredPerpFundingMultiplier',
        type: 'int256'
      }
    ],
    name: 'setSquaredPerpFundingMultiplier',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_tradeFeeRate',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_protocolFeeRate',
        type: 'int256'
      }
    ],
    name: 'setTradeFeeRate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_margin',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_totalLiquidityAmount',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_deltaMargin',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_deltaLiquidity',
        type: 'int256'
      }
    ],
    name: 'testCalculateFundingRate',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_spotPrice',
        type: 'int256'
      },
      {
        internalType: 'uint256',
        name: '_currentTimestamp',
        type: 'uint256'
      }
    ],
    name: 'testCalculateResultOfFundingPayment',
    outputs: [
      {
        internalType: 'int256',
        name: 'currentFundingRate',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: 'fundingFeePerPosition',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: 'fundingReceived',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'enum PerpetualMarketCore.MarginChange',
        name: '_marginChangeType',
        type: 'uint8'
      },
      {
        internalType: 'int256',
        name: '_deltaMargin',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_currentMarginAmount',
        type: 'int256'
      }
    ],
    name: 'testCalculateSignedDeltaMargin',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amountLockedLiquidity',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_deltaM',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '_hedgePositionValue',
        type: 'int256'
      }
    ],
    name: 'testCalculateUnlockedLiquidity',
    outputs: [
      {
        internalType: 'int256',
        name: 'deltaLiquidity',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: 'unlockLiquidityAmount',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_spotPrice',
        type: 'int256'
      }
    ],
    name: 'testExecuteFundingPayment',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      }
    ],
    name: 'testGetSignedMarginAmount',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_tradeAmount',
        type: 'int128'
      }
    ],
    name: 'testUpdatePoolPosition',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_timestamp',
        type: 'uint256'
      }
    ],
    name: 'testUpdateVariance',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_productId',
        type: 'uint256'
      },
      {
        internalType: 'int128',
        name: '_tradeAmount',
        type: 'int128'
      }
    ],
    name: 'updatePoolPosition',
    outputs: [
      {
        internalType: 'uint256',
        name: 'tradePrice',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'uint256',
        name: 'protocolFee',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'updatePoolSnapshot',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_withdrawer',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_withdrawnAmount',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [
      {
        internalType: 'uint256',
        name: 'burnAmount',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class PerpetualMarketCoreTester__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _priceFeedAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PerpetualMarketCoreTester> {
    return super.deploy(
      _priceFeedAddress,
      overrides || {}
    ) as Promise<PerpetualMarketCoreTester>
  }
  getDeployTransaction(
    _priceFeedAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_priceFeedAddress, overrides || {})
  }
  attach(address: string): PerpetualMarketCoreTester {
    return super.attach(address) as PerpetualMarketCoreTester
  }
  connect(signer: Signer): PerpetualMarketCoreTester__factory {
    return super.connect(signer) as PerpetualMarketCoreTester__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PerpetualMarketCoreTesterInterface {
    return new utils.Interface(_abi) as PerpetualMarketCoreTesterInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PerpetualMarketCoreTester {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PerpetualMarketCoreTester
  }
}
